module.exports = __webpack_public_path__ + "img/ic-manage-account_color.44abf499.svg";